import { INPUTCOL, MINCOL } from "../../../constants/const"
import ZeileLöschenBD from "../../Datenerfassung/Bearbeitung/ZeileLöschenBD";
import DeChecks from "../../Datenerfassung/DeChecks";
import CommentCellDatenerfassung from "../CommentCellDatenerfassung";
import EditableCell from "../EditableCell";
import DropdownFilter from "../SD_einsehen/DropdownFilter"
import NoFilterButUnit from "../SD_einsehen/NoFilter";

export const bhfdatenHeader = [
    {accessor: 'jahr',
    Header: 'Jahr',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'vv',
    Header: 'Verkehrsvertrag',
    width: '12em',
    Filter: DropdownFilter},
    {accessor: 'zv',
    Header: 'Zweckverband',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'linie',
    Header: 'Linie',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'bhf',
    Header: 'Bahnhof',
    width: '12em',
    Filter: DropdownFilter},
    {accessor: 'prod',
    Header: 'Produkt',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'tg',
    Header: 'Tagesgruppe',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'richtung',
    Header: 'Richtung',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'fahrtage',
    Header: 'Fahrtage',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'halte',
    Header: 'Anz Halte',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'einsteiger',
    Header: 'Einsteiger',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'aussteiger',
    Header: 'Aussteiger',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'status',
    Header: 'Status',
    Filter: DropdownFilter,
    width: MINCOL},
    {accessor: 'checked',
    Header: 'Status ändern',
    Cell: DeChecks,
    width: MINCOL},
    {accessor: 'kommentar',
    Header: 'Kommentar',
    Cell: CommentCellDatenerfassung
    },
    {accessor: 'del',
    Header: 'Löschen',
    Cell: ZeileLöschenBD
    }
];

export const hiddenColumns = ['vvlpId', 'bhfsdatId', 'vvId', 'zvId', 'linieId', 'prodId', 'bhfId', 'tgId'];

export const bhfsdCsvHeader = [
    {key: 'code',
    label: 'Schluessel'},
    {key: 'jahr',
    label: 'Jahr'},
    {key: 'vv',
    label: 'Verkehrsvertrag'},
    {key: 'zv',
    label: 'Zweckverband'},
    {key: 'linie',
    label: 'Linie'},
    {key: 'bhf',
    label: 'Bahnhof'},
    {key: 'prod',
    label: 'Produkt'},
    {key: 'richtung',
    label: 'Richtung'},
    {key: 'tg',
    label: 'Tagesgruppe'},
    {key: 'fahrtage',
    label: 'Fahrtage'},
    {key: 'halte',
    label: 'Halte'},
    {key: 'einsteiger',
    label: 'Einsteiger'},
    {key: 'aussteiger',
    label: 'Aussteiger'},
    {key: 'status',
    label: 'Status'}];